var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3.5,37.5 3.5,2.5 21.793,2.5 30.5,11.207 30.5,37.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#788B9C"
    },
    d: "M21.586,3L30,11.414V37H4V3H21.586 M22,2H3v36h28V11L22,2L22,2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "21.5,11.5 21.5,2.5 21.793,2.5 30.5,11.207 30.5,11.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#788B9C"
    },
    d: "M22,3.414L29.586,11H22V3.414 M22,2h-1v10h10v-1L22,2L22,2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,9h4V8H7V9z M14,8v1h6V8H14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,11h4v-1H7V11z M14,10v1h6v-1H14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,13h4v-1H7V13z M23,12v1h4v-1H23z M14,13h6v-1h-6V13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,30h4v-1H7V30z M23,29v1h4v-1H23z M14,30h6v-1h-6V30z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,32h4v-1H7V32z M23,31v1h4v-1H23z M14,32h6v-1h-6V32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M7,34h4v-1H7V34z M23,33v1h4v-1H23z M14,34h6v-1h-6V34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    style: {
      fill: "#5E9C76"
    },
    width: 28,
    height: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    style: {
      fill: "#BAE0BD"
    },
    width: 3,
    height: 7
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M11.762,18.402v0.541H9.962v-0.46c0-0.83-0.77-1.002-1.112-1.002c-0.447,0-1.111,0.108-1.111,1.124 l0,4.926c0,0.281,0.01,0.989,1.094,0.989c1.022,0,1.129-0.784,1.129-0.974v-0.474h1.799v0.596c0,0.792-0.797,2.233-2.858,2.233 c-0.342,0-2.964-0.036-2.964-2.274l0-5.307c0-0.986,0.839-2.219,2.929-2.219C11.408,16.1,11.762,17.865,11.762,18.402z M17.676,16.1 c-2.996,0-3.087,2.278-3.087,2.639c0,1.872,1.182,2.234,1.958,2.478l1.288,0.405c0.803,0.284,1.04,0.337,1.04,1.461 c0,1.166-0.339,1.435-1.305,1.435c-1.03,0-1.27-0.57-1.27-0.989v-0.432l-1.799,0l0,0.514c0,1.671,1.903,2.287,3.069,2.287 c2.416,0,3.105-1.322,3.105-2.829c0-1.936-0.842-2.29-1.887-2.639l-1.376-0.42c-1.042-0.317-0.979-0.674-0.996-0.805 c-0.017-0.131-0.027-0.291-0.027-0.48c0-1.257,0.97-1.246,1.217-1.246c1.118,0,1.27,0.849,1.27,1.165v0.31l1.799,0V18.28 C20.674,17.548,19.883,16.1,17.676,16.1z M27.004,16.181l-1.447,6.729h-0.035l-1.429-6.729l-1.904,0l2.557,9.638h1.588l2.575-9.638 L27.004,16.181z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6E3ED"
    },
    points: "30,23 30,37 27.608,37 28.399,38 31,38 31,23 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9CACBD"
    },
    points: "25.041,30.5 29.5,30.5 29.5,22.5 34.5,22.5 34.5,30.5 38.959,30.5 32,39.199  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36404D"
    },
    d: "M34,23v7v1h1h2.919L32,38.399L26.081,31H29h1v-1v-7H34 M35,22h-6v8h-5l8,10l8-10h-5V22L35,22z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportCsv);
export default __webpack_public_path__ + "static/media/Export CSV.c50b533e498c064ee5c885a816a5c358.svg";
export { ForwardRef as ReactComponent };